<template>
  <div class="wx-login">
    <m-loading :loading="isRegister" :text="tips"></m-loading>
    <div v-if="!isRegister" class="wx-bind-phone customer-common">
      <div class="greeting">
        <!-- <div></div> -->
        <p>绑定手机号</p>
      </div>
      <div class="bind-phone-content cus-style">
        <div class="input">
          <van-field
            v-model="phone"
            center
            clearable
            maxlength="11"
            placeholder="请输入手机号"
            :error="validate.reg_verify_err.phone"
            @change="validate.tel('phone')"
          >
          </van-field>
          <van-field
            v-model="code"
            center
            clearable
            placeholder="请输入验证码"
            type="digit"
            max-length="6"
            :error="validate.reg_verify_err.code"
            @change="validate.code('code')"
          >
            <template #button>
              <span
                size="small"
                round
                @click="sendCode"
                style="color: #6cdd8f"
                >{{ sendClip ? "发送验证码" : `${second}s` }}</span
              >
            </template>
          </van-field>
        </div>
        <div class="sub-btn">
          <van-button
            size="large"
            color="linear-gradient(to right, #5DD682, #5AFF8E)"
            @click="registerAndLogin"
            >提交</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { wxlogin } from "@/utils/mixin/wxlogin";
import { validate } from "@/utils/mixin/validate";
import {
  wechatLogin,
  wechatRegister,
  getRegiserTelCode
} from "@/utils/api/user";
import { mapActions } from "vuex";
export default {
  mixins: [validate, wxlogin],
  data() {
    return {
      // 手机号
      phone: null,
      // 验证码
      code: null,
      // 微信用户信息
      wxuserinfo: null,
      // 用户是否注册
      isRegister: true,
      sendClip: true,
      itv: null,
      second: 60,
      tips: "加载中……"
    };
  },
  methods: {
    ...mapActions(["setUserInfo", "setRole"]),
    // 发送验证码
    sendCode() {
      if (!this.sendClip) {
        return;
      }
      const res = this.validate.tel("phone");
      if (!res) {
        this.$root.$toast.fail("请输入正确的手机号码！");
        return;
      }
      getRegiserTelCode(this.phone).then((res) => {
        if (res.success) {
          this.sendClip = false;
          this.codeInterval();
        }
      });
    },
    // 倒计时
    codeInterval() {
      this.itv = setInterval(() => {
        this.second--;
        if (!this.second) {
          this.second = 60;
          this.sendClip = true;
          window.clearInterval(this.itv);
        }
      }, 1000);
    },
    // 重定向回调
    wxLoginCallback(wxuserinfo) {
      this.wxuserinfo = wxuserinfo;
      this.checkUserRegister();
    },
    // 登录并检测用户是否注册
    checkUserRegister() {
      this.tips = "登录中……";
      const { openid ,unionid} = this.wxuserinfo;
      wechatLogin({ openId: openid ,unionId:unionid}).then((res) => {
        if (res.success) {
          if (res.data) {
            this.setUserInfo(res.data);
            const userType = parseInt(res.data.userType);
            switch (userType) {
              case 1:
                this.setRole(0);
                break;
              case 3:
                this.setRole(1);
                break;
              case 4:
                this.setRole(2);
                break;
              case 5:
                this.setRole(3);
                break;
              default:
                this.setRole(-1);
                break;
            }
            this.$root.$toast.success({
              message: "登录成功",
              duration: 1500,
              onClose: () => {
                // this.$router.push("/home");
                // push 会导致js sdk 的签名失效，且不会刷新签名，定位和扫码功能都不能使用。这里使用 window.location.href
                // window.location.href = window.location.origin + "/home";
                this.$root.mipLink("/");
              }
            });
          } else {
            document.title = "绑定手机号";
            this.isRegister = false;
          }
        }
      });
    },
    // 注册并登录
    registerAndLogin() {
      const res = this.validate.tel("phone");
      if (!res) {
        this.$root.$toast.fail("请输入正确的手机号码！");
        return;
      }
      const res2 = this.validate.code("code");
      if (!res2) {
        this.$root.$toast.fail(this.validate.reg_verify_err.code);
        return;
      }
      const { nickname, openid, headimgurl,unionid} = this.wxuserinfo;
      const p = {
        nickName: nickname,
        openId: openid,
        userImg: headimgurl,
        code: this.phone,
        telCode: this.code,
        unionId:unionid
      };
      wechatRegister(p).then((res) => {
        if (res.success) {
          this.setUserInfo(res.data);
          const userType = parseInt(res.data.userType);
          switch (userType) {
            case 1:
              this.setRole(0);
              break;
            case 3:
              this.setRole(1);
              break;
            case 4:
              this.setRole(2);
              break;
            case 5:
              this.setRole(3);
              break;
            default:
              this.setRole(-1);
              break;
          }
          this.$root.$toast.success({
            message: "登录成功",
            duration: 1500,
            onClose: () => {
              // this.$router.push("/home");
              // push 会导致js sdk 的签名失效，且不会刷新签名，定位和扫码功能都不能使用。这里使用 window.location.href
              // window.location.href = window.location.origin + "/home";
              this.$root.mipLink("/");
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.wx-login {
  height: 100%;
  width: 100%;
  .wx-bind-phone {
    .greeting {
      width: 100%;
      color: #666;
      overflow: hidden;
      & > p {
        font-size: 20px;
        margin-top: 50px;
        color: #333;
        font-weight: 700;
      }
    }
    .input {
      width: 335px;
      overflow: hidden;
      margin: 30px auto;
    }
    .sub-btn {
      margin-top: 50px;
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";
</style>
